export enum ShippingCategoryEnum {
  ShippingCategoryCollection="ShippingCategoryCollection",
  ShippingCategory="ShippingCategory",
}
export enum ShippingCategoryDataStatus {
  active = "active",
  inactive = "inactive",
}
